export default __webpack_public_path__ + "static/media/Logo-Modal.d1f33c01.svg";